import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

const COLUMNS = [
  {
    title: "Solutions",
    links: [
      { label: "Business Operations", to: "/solutions#business-operations" },
      { label: "Customer Operations", to: "/solutions#customer-operations" },
      { label: "Sales & Lead Generation", to: "/solutions#sales-lead-generation" },
      { label: "Social Media & Marketing", to: "/solutions#social-media-marketing" },
      { label: "Finance & Accounting", to: "/solutions#finance-accounting" },
      { label: "IT Services", to: "/solutions#it-services" },
      { label: "Professional Services", to: "/professional-services" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "How It Works", to: "/how-it-works" },
      { label: "Industries", to: "/industries" },
      { label: "Case Studies", to: "/case-studies" },
      { label: "Contact", to: "/contact" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", to: "/privacy" },
      { label: "Terms", to: "/terms" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-ink">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-5">
          <div className="col-span-2">
            <Link to="/" aria-label="Synergy Outsourcing home">
              <img
                src="/logo-full.png"
                alt="Synergy Outsourcing"
                className="h-[72px] w-auto"
                data-testid="footer-logo"
              />
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-mist">
              Australian-led managed global talent for growing businesses. Build a better team without building a
              bigger overhead.
            </p>
            <a
              href="mailto:info@synergyos.com.au"
              data-testid="footer-email"
              className="mt-4 inline-flex items-center gap-2 text-sm text-slate-300 transition-colors hover:text-brand"
            >
              <Mail className="h-4 w-4 text-brand" />
              info@synergyos.com.au
            </a>
          </div>
          {COLUMNS.map((col) => (
            <div key={col.title}>
              <h3 className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
                {col.title}
              </h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/[\s&]+/g, "-")}`}
                      className="text-sm text-slate-400 transition-colors hover:text-white"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} Synergy Outsourcing. All rights reserved.</p>
          <p className="font-mono text-xs tracking-wide text-slate-500" data-testid="footer-transparency">
            Synergy Outsourcing is an Australian company, operating across Australia, the US and Canada.
          </p>
        </div>
      </div>
    </footer>
  );
}
